import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenecen estas pantallas (encabezado de la bandeja). */
const SECCION = 'Serología (SER)';

export const serologiaRoutes: Routes = [
  {
    path: 'serologia/brucelosis',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Diagnóstico de brucelosis',
    data: {
      pantalla: 'BRUCELOSIS',
      breadcrumb: SECCION,
      titulo: 'Diagnóstico de brucelosis',
      permiso: Permiso.BRUCELOSIS_VER,
    },
  },
  {
    // Brucelosis en leche: una sola hoja para la prueba de anillo y el ELISA; el
    // método se elige en la hoja (formato IHIMV-RT-21-SER-1).
    path: 'serologia/brucelosis-leche',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Brucelosis en leche',
    data: {
      pantalla: 'BRUCELOSIS_LECHE',
      breadcrumb: SECCION,
      titulo: 'Brucelosis en leche',
      permiso: Permiso.BRUCELOSIS_LECHE_VER,
    },
  },
  {
    path: 'serologia/brucelosis-leche/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'BRUCELOSIS_LECHE',
      permiso: [Permiso.BRUCELOSIS_LECHE_RESULTADOS, Permiso.BRUCELOSIS_LECHE_VER],
    },
    loadComponent: () =>
      import('./pages/brucelosis-anillo-resultados/brucelosis-anillo-resultados.page').then(
        (m) => m.BrucelosisAnilloResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Brucelosis en leche',
  },
  {
    path: 'serologia/brucelosis/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'BRUCELOSIS',
      permiso: [Permiso.BRUCELOSIS_RESULTADOS, Permiso.BRUCELOSIS_VER],
    },
    loadComponent: () =>
      import('./pages/brucelosis-resultados/brucelosis-resultados.page').then(
        (m) => m.BrucelosisResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Brucelosis',
  },
  {
    path: 'serologia/tuberculosis',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Tuberculosis bovina (ELISA)',
    data: {
      pantalla: 'TUBERCULOSIS',
      breadcrumb: SECCION,
      titulo: 'Tuberculosis bovina (ELISA)',
      permiso: Permiso.TUBERCULOSIS_VER,
    },
  },
  {
    path: 'serologia/tuberculosis/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'TUBERCULOSIS',
      permiso: [Permiso.TUBERCULOSIS_RESULTADOS, Permiso.TUBERCULOSIS_VER],
    },
    loadComponent: () =>
      import('./pages/tuberculosis-resultados/tuberculosis-resultados.page').then(
        (m) => m.TuberculosisResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Tuberculosis bovina (ELISA)',
  },
];
